import { AgentPresenceEventStatus } from '@repo/sdk/models/components';

import { useUserActivity } from '@/hooks/query-hooks/gaia-api/activity';
import { useCurrentFacility } from '@/hooks/use-current-facility';

export interface UseCurrentAgentStatusResult {
  /**
   * The current agent presence status.
   */
  status: AgentPresenceEventStatus;
  /**
   * The time at which the agent presence status was last updated.
   */
  statusAt: Date;
  /**
   * Agent Presence is reporting agent offline.
   */
  isOffline: boolean;
}

/**
 * Determine whether the user's current facility is offline.
 */
export const useCurrentAgentStatus = (): UseCurrentAgentStatusResult => {
  const { currentFacility } = useCurrentFacility();
  const { agents } = currentFacility ?? {};
  const { data: agentPresence } = useUserActivity();

  if (!agents?.length) {
    return {
      status: AgentPresenceEventStatus.Online,
      statusAt: new Date(),
      isOffline: false,
    };
  }

  const { agentId } = agents[0];
  const latestAgentPresence = agentPresence?.find((presence) => presence.agentId === agentId);

  const status = latestAgentPresence?.status ?? AgentPresenceEventStatus.Online;
  const statusAt = latestAgentPresence?.statusAt ?? new Date();

  const isOffline = status === AgentPresenceEventStatus.Offline;

  return {
    status,
    statusAt,
    isOffline,
  };
};
